import React, { useMemo } from 'react';
import { Button, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { Information } from '../../assets/icons';
import './PropertyBuyCard.scss';
import { cardData } from '../../pages/PropertyListing/IOVacationData';
import { useSelector } from 'react-redux';
import { getUsCurrencyFormat, getUsCurrencyFormatWithoutDecimal } from '../../utils/usCurrencyFormatter';
import useScroll from '../../Hooks/useScroll';
import { maxShareCalculatorWithNoOfShare } from '../../utils/maxShareCalculator';
import { remainingDays } from '../../utils/remainingDaysCalculator';
import { NOT_SHOWING_CALL_OPTIPN } from '../../utils/constant';
import Phone from '../../assets/icons/Phone';

const PropertyBuyCard = ({ onBuyClick, onNotifyClick, isFetchingUserAccount }) => {
  const { data, loading } = useSelector((state) => state.propertyDetails);
  // Check if secondary market is paused from API response
  useScroll('.data-list');

  const notifyLoading = useSelector((state) => state.notifyMeSlice.loading);
  const newCardData = {
    ...cardData,
    cardInfoData: cardData.cardInfoData.map((x) => {
      switch (x.label) {
        case 'Shares remaining':
          x.value = getUsCurrencyFormatWithoutDecimal(Number(data?.data?.sharesRemaining) || 0) || '0';
          break;
        case 'Investors':
          x.value = getUsCurrencyFormatWithoutDecimal(Number(data?.data?.noOfInvestors) || 0) || '0';
          break;
        case 'Share Price':
          x.value = getUsCurrencyFormat(Number(data?.data?.finance?.perSharePrice || 0)) || '0';
          break;
          // CR-158 Hide funding bar and set Static Label
        case 'Shares Available':
          x.value = (data?.data?.tag === 'Funded' || data?.data?.tag === 'Closed' || Number(data?.data?.sharesRemaining) === 0) ? 'No' : 'Yes';
          break;
        case 'Estimated Dividend Yield':
          x.value = data?.data?.tenantStatus?.dividendYield ?? 'NA';
          break;
        default:
          break;
      }
      x.value = x.prefix ? `${x.prefix}${x.value}` : x.value;
      return x;
    }),
  };
  const fundingProgress = useMemo(() => {
    // if (data?.data?.totalShare && data?.data?.sharesPurchased) {
    //   return getUsPercentageFormat((Number(data?.data?.sharesPurchased) * 100) / Number(data?.data?.totalShare), 4);
    // }
    if (data?.data?.percentageFunded) {
      return data?.data?.percentageFunded;
    }
    return 0;
  }, [data?.data?.percentageFunded]);

   const isBuyDisabled =
    data?.data?.tag === 'Funded' ||
    data?.data?.tag === 'Closed' ||
    data?.data?.tag === 'Next Investment Window: December' ||
    Number(fundingProgress) >= 100 ||
    maxShareCalculatorWithNoOfShare(Number(data?.data?.totalShare), 0, Number(data?.data?.userPurchaseDetail?.noOfShares)) < 1;

  return (
    <div className='buy-initial'>
      {data?.data?.tag !== 'Coming Soon' ? (
        <>
          {(remainingDays(data?.data?.duration) >= 0 || loading) && (
            <Button
              disabled={isBuyDisabled}
              className='w-100 mb-24'
              type='primary'
              onClick={onBuyClick}
              loading={isFetchingUserAccount}
            >
              {newCardData.buyLabel}
            </Button>
            // removed This property has been expired.
          )}
        </>
      ) : (
        <Button
          className='w-100 mb-24'
          onClick={() => onNotifyClick({ id: data?.data?.propertyId, isSecondary: data?.data?.isSecondary })}
          loading={notifyLoading}
        >
          Notify me
        </Button>
      )}
      <div className='data-list'>
        {newCardData.cardInfoData.map((cardInfo, index) => {
          return (
            <div className='data-list__item' key={index}>
              <Tooltip title={cardInfo.tooltip}>
                <span className={cardInfo.tooltip ? 'data-list__item__label tooltip' : 'data-list__item__label'}>
                  {/* CR-158 Hide funding bar and set Static Label */}
                  {cardInfo.label} {cardInfo.tooltip && <Information marginLeft='4px' />}
                </span>
              </Tooltip>
              <span className='data-list__item__value'>{cardInfo.value}</span>
            </div>
          );
        })}
      </div>
      {/* {data?.data?.tag !== 'Funded' && data?.data?.tag !== 'Closed' && fundingProgress >= 0 ? (
        <div className={`progressbar ${fundingProgress > 0 ? 'progressbar--copper' : ''}`}>
          <Progress percent={fundingProgress} format={(percent) => `${getUsCurrencyFormat(percent)}% funded`} />
        </div>
      ) : (
        ''
      )} */}

      {!NOT_SHOWING_CALL_OPTIPN.includes(data?.data?.tag) && !isBuyDisabled && (remainingDays(data?.data?.duration) >= 0) && (
        <div className='data-list v-center-items'>
          <div className='data-list__item'>
            <span className={'data-list__item__label'}>
              Questions about this property? Call or text us!
            </span>
            <div className='call-cta'>
              <a href='tel:+1-986-219-5819' className='call-contact'><Phone/> 986-219-5819</a>
              <Button type='primary' ghost size='small' shape='round' onClick={() => window.open('https://go.realbricks.com/book-a-call-2', '_blank','noopener,noreferrer')}>Book a Call</Button>
            </div>
          </div>
        </div>
)}
    </div>
  );
};
PropertyBuyCard.propTypes = {
  onBuyClick: PropTypes.func,
  onNotifyClick: PropTypes.func,
  isFetchingUserAccount: PropTypes.bool
};

export default PropertyBuyCard;
